import { render } from "./ProductionView.vue?vue&type=template&id=5d3ac9fc&scoped=true"
import script from "./ProductionView.vue?vue&type=script&lang=js"
export * from "./ProductionView.vue?vue&type=script&lang=js"

import "./ProductionView.vue?vue&type=style&index=0&id=5d3ac9fc&lang=stylus&scoped=true"
import "./ProductionView.vue?vue&type=style&index=1&id=5d3ac9fc&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3ac9fc"]])

export default __exports__